import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageTitle, MatchBadge } from "@/components/studio/common";
import { api, dt } from "@/lib/api";

export default function Searches() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/searches").then((r) => setRows(r.data)); }, []);
  return (
    <div data-testid="searches-page">
      <PageTitle title="Log ricerche" sub="Registro di ogni verifica effettuata dal form pubblico (accountability GDPR)" />
      <div className="bg-white border border-slate-200 rounded-xl overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500"><tr>
            {["Data", "Nominativo", "C.F.", "Modalità", "Esito", "IP", "Pratica"].map((h) => <th key={h} className="text-left px-4 py-3">{h}</th>)}
          </tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-slate-100" data-testid={`search-row-${r.id}`}>
                <td className="px-4 py-2.5 text-xs">{dt(r.at)}</td><td className="px-4">{r.nominativo}</td>
                <td className="px-4 font-mono text-xs">{r.codice_fiscale}</td>
                <td className="px-4 text-xs">{r.mode === "immediate" ? "Esito immediato" : "Ricontatto"}</td>
                <td className="px-4"><MatchBadge m={{ status: r.result, score: r.score }} /></td>
                <td className="px-4 font-mono text-xs">{r.ip}</td>
                <td className="px-4"><Link to={`/studio/pratiche/${r.pratica_id}`} className="text-navy underline text-xs">Apri</Link></td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={7} className="text-center py-10 text-slate-500">Nessuna ricerca registrata</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
